import { yup } from '@guiker/yup-util'

export const bookingIdApplicantUserIdPathParamsSchema = yup.object({
  bookingId: yup.string().required(),
  applicantUserId: yup.string().required(),
})

export type BookingIdApplicantUserIdPathParmsSchema = yup.InferType<typeof bookingIdApplicantUserIdPathParamsSchema>
